import { css, type SerializedStyles } from '@emotion/react'

import { RADIUS_1 } from '@Styles/constants/radius'

import { type MediaRadius, type MediaRatio } from './Media.types'

export const getRadius = (radius: MediaRadius): SerializedStyles =>
  css(
    {
      full: { borderRadius: RADIUS_1 },
      left: { borderRadius: `${RADIUS_1} 0 0 ${RADIUS_1}` },
      right: { borderRadius: `0 ${RADIUS_1} ${RADIUS_1} 0` },
      top: { borderRadius: `${RADIUS_1} ${RADIUS_1} 0 0` },
      without: { borderRadius: 0 },
    }[radius],
  )

const getRatio = ([width, height]: MediaRatio): SerializedStyles =>
  css({
    aspectRatio: `${width} / ${height}`,
  })

// cas nominal => object-fit: contain
// cas cover => object-fit: cover + height: 100%
export const image = (fit: 'contain' | 'cover', ratio?: MediaRatio): SerializedStyles =>
  css(
    {
      height: '100%',
    },
    fit === 'contain' && { objectFit: 'contain' },
    ratio && getRatio(ratio),
  )

export const video = css({
  border: 'none',
})
